import { API_ENDPOINTS, apiRequest, HttpMethods } from "@alba-cars/common-modules";

export const notifyWebhookAboutBankValuationUpdate = async (updatedData: Record<string, any>) => {
  const endpoint = API_ENDPOINTS.bankValuationRequest.notifyAboutExistingLead.toString();

  const response = await apiRequest<{ message: string }>(endpoint, {
    method: HttpMethods.POST,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updatedData),
  });
  return response;
};
